import { useState } from "react";

import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";

import Heading from "@atlaskit/heading";
import { Inline, Stack, Grid } from "@atlaskit/primitives-next";

import { TAB_KEYS, TABS, USEFUL_LINKS, RESOURCE_LINK_CARDS } from "./constants";
import { useResourcesPageAnalytics } from "./hooks";
import { LinkCardWrapper } from "./link-card-wrapper";
import { messages } from "./messages";
import { ResourceLinkCard } from "./resource-link-card";
import { TabSelector } from "./tab-selector";

export const FastshiftResourcesPage = () => {
    const [currentTab, setCurrentTab] = useState<TAB_KEYS>(TAB_KEYS.ALL);

    const { domainId } = useParams<{ domainId: string }>();
    const isDomainScoped = Boolean(domainId);

    useResourcesPageAnalytics(isDomainScoped);

    return (
        <Stack space="space.300">
            <Heading size="large">
                <FormattedMessage {...messages.pageHeading} />
            </Heading>

            <TabSelector
                currentTab={currentTab}
                tabs={TABS}
                isDomainScoped={isDomainScoped}
                onTabSelect={setCurrentTab}
            />
            <Grid gap="space.200" templateColumns="1fr 1fr 1fr">
                {RESOURCE_LINK_CARDS.filter(
                    (card) =>
                        currentTab === TAB_KEYS.ALL ||
                        card.category === currentTab
                ).map((card) => (
                    <ResourceLinkCard
                        key={card.id}
                        {...card}
                        isDomainScoped={isDomainScoped}
                    />
                ))}
            </Grid>
            <Inline space="space.200" grow="fill">
                <LinkCardWrapper
                    heading={messages.usefulLinksHeading}
                    links={USEFUL_LINKS}
                    isDomainScoped={isDomainScoped}
                />
            </Inline>
        </Stack>
    );
};
